module.exports = __webpack_public_path__ + "static/40-cef984a9f764571209d60849e7e3e709.png";